import { ref, onMounted, onUnmounted } from 'vue'
import { getDeviceUptime} from '@/services/mivulite/metricsService'

export function useDeviceUptime(refreshInterval = 30_000) {
  const uptimeByName = ref({})
  const uptimeByMac = ref({})
  let intervalId = null

  async function fetchUptimeMetrics() {
    try {
      const results = await getDeviceUptime()

      const newByName = {}
      const newByMac = {}

      results.forEach(({ metric, value }) => {
        const seconds = parseFloat(value[1])

        if (metric.device_name) {
          newByName[metric.device_name.toLowerCase()] = seconds
        }
        if (metric.mac) {
          const normalized = metric.mac.toUpperCase().replace(/-/g, ':')
          newByMac[metric.mac] = seconds
          newByMac[normalized] = seconds
        }
      })

      uptimeByName.value = newByName
      uptimeByMac.value = newByMac
    } catch (err) {
      console.error('Failed to fetch uptime metrics:', err)
    }
  }

  onMounted(() => {
    fetchUptimeMetrics()
    intervalId = setInterval(fetchUptimeMetrics, refreshInterval)
  })

  onUnmounted(() => {
    clearInterval(intervalId)
  })

  function resolveUptime(device) {
    if (!device.is_online) return null;
    

    const name = (device.name || '').toLowerCase()
    const mac = (device.mac_address || '').toUpperCase().replace(/-/g, ':')

    return uptimeByName.value[name]
      ?? uptimeByMac.value[mac]
      ?? null
  }

  function formatUptime(seconds) {
    if (seconds == null) return '—'
    const d = Math.floor(seconds / 86400)
    const h = Math.floor((seconds % 86400) / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const parts = []
    if (d) parts.push(`${d}d`)
    if (h) parts.push(`${h}h`)
    if (m) parts.push(`${m}m`)
    return parts.length ? parts.join(' ') : '< 1m'
  }

  return { fetchUptimeMetrics, resolveUptime, formatUptime }
}